module.exports = __webpack_public_path__ + "static/poster3-f0975bc35ac2162baba1dce3ad46ed97.jpg";